import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./app/store";
import App from "./App";
import { ThemeProvider } from "@emotion/react";
import { themeOptions } from "./theme/theme";
import { BrowserRouter } from "react-router-dom";
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ThemeProvider theme={themeOptions}>
      <Provider store={store}>
        <App/>
      </Provider>
    </ThemeProvider>
  </BrowserRouter>
);
